/** @format */
/** @format */

import React, { FC, useState, useEffect } from 'react'
import styled from 'styled-components'
import {
  _$,
  Button,
  Select,
  Option,
  Icon,
  Table,
  TableColumn,
  Pagination,
  Dialog,
  Message
} from '@king-design/react'
import { MonitorSearch, TableSearch, parseTableSearchParams } from 'src/components'
import { PrometheusAlarmTabProps } from 'src/pages/PrometheusMonitor/Alarm'
import { PageProps, initPage } from 'src/utils/interface'
import { useHistory, useLocation } from 'react-router-dom'
import { useAsyncFn } from 'react-use'
import {
  getPrometheusAlertTemplateList,
  deletePrometheusAlertTemplate
} from 'src/api/ApiPrometheusAlarm'
export const TemplateTypeEnum = {
  0: '全部',
  1: '系统模板',
  2: '自定义模板'
}
interface SearchProps extends PageProps {
  Name: string
  Type: 0 | 1 | 2
}

const initSearch: SearchProps = {
  Name: '',
  Type: 0,
  ...initPage
}

const PrometheusAlarmTemplate: FC<PrometheusAlarmTabProps> = ({ className }) => {
  const history = useHistory()
  const location = useLocation()
  const [search, setSearch] = useState<SearchProps>(
    () => parseTableSearchParams<SearchProps>(location.search) || initSearch
  )

  const [{ value: tableData }, fetch] = useAsyncFn(
    async (params?) => {
      const result = await getPrometheusAlertTemplateList({
        ...search,
        ...params
      })
      return {
        data: result?.AlertTemplates || [],
        total: result?.TotalCount || 0
      }
    },
    [search]
  )

  useEffect(() => {
    fetch()
  }, [search])

  // 删除模板
  const [, deleteFetch] = useAsyncFn(async TemplateID => {
    const result = await deletePrometheusAlertTemplate({
      TemplateID
    })
    if (result?.code === 'Success') {
      Message.success(_$('删除成功'))
      setSearch({
        ...search,
        Page: 1
      })
    } else {
      result?.message && Message.error(result?.message)
    }
  }, [])

  return (
    <div className={className}>
      <TableSearch params={search}>
        <div className="search_item">
          <Select
            value={search.Type}
            clearable
            placeholder={_$('请选择模板类型')}
            slotPrefix={`${_$('模板类型')}：`}
            onChangeValue={value => {
              setSearch({
                ...search,
                Page: 1,
                Type: value
              })
            }}
          >
            {Object.keys(TemplateTypeEnum).map(key => (
              <Option key={key} value={Number(key)}>
                {_$(TemplateTypeEnum[key])}
              </Option>
            ))}
          </Select>
        </div>
        <div className="search_item">
          <MonitorSearch
            placeholder={_$('请输入模板，支持模糊搜索')}
            value={search.Name}
            prefix={`${_$('模板名称')}：`}
            onChange={value => {
              setSearch({
                ...search,
                Page: 1,
                Name: value
              })
            }}
          />
        </div>
      </TableSearch>
      <div className="header">
        <Button
          type="primary"
          onClick={() => {
            history.push(`/monitor/prometheusmonitor/alarm/edit?page=template&tab=template`)
          }}
        >
          <Icon className="ion-plus-round" />
          {_$('新建告警模板')}
        </Button>
      </div>
      <Table
        stickHeader={50}
        data={tableData?.data || []}
        animation={false}
        rowKey={data => data.ID}
        checkType="none"
      >
        <TableColumn key="Name" title={_$('模板名称')} />
        <TableColumn
          key="Type"
          title={_$('类型')}
          slotTemplate={([data]) => {
            return data.Type in TemplateTypeEnum ? _$(TemplateTypeEnum[data.Type]) : _$('未知类型')
          }}
        ></TableColumn>
        <TableColumn
          key="operate"
          title={_$('操作')}
          width="150"
          slotTemplate={([data]) => {
            return data.Type === 2 ? (
              <div className="ksc-space">
                {/* 编辑 */}
                <a
                  onClick={() => {
                    if (!data.ID === undefined) {
                      Message.error(_$('模板ID为空'))
                      return
                    }
                    history.push(
                      `/monitor/prometheusmonitor/alarm/edit?page=template&templateid=${data.ID}&tab=template`
                    )
                  }}
                >
                  {_$('编辑')}
                </a>
                {/* 删除 */}
                <a
                  onClick={() => {
                    let dialog: Dialog
                    Dialog.confirm({
                      content: `${_$('是否确认删除告警模板')}?`,
                      ref: _dialog => (dialog = _dialog),
                      okText: _$('确认删除'),
                      ok: async () => {
                        dialog.showLoading()
                        await deleteFetch(data.ID)
                        dialog.close()
                      }
                    })
                  }}
                >
                  {_$('删除')}
                </a>
              </div>
            ) : (
              '-'
            )
          }}
        ></TableColumn>
      </Table>
      {tableData !== undefined ? (
        <Pagination
          value={search.Page}
          limit={search.PageSize}
          total={tableData?.total || 0}
          size="small"
          onChangeValue={value => {
            setSearch({
              ...search,
              Page: value
            })
          }}
          onChangeLimit={limit => {
            setSearch({
              ...search,
              PageSize: limit
            })
          }}
        />
      ) : null}
    </div>
  )
}

export default styled(PrometheusAlarmTemplate)`
  .k-table {
    .table_status {
      b {
        margin: 0 4px;
      }
    }
  }
`
